module.exports = __webpack_public_path__ + "static/media/Hercules.cc05c9b7.png";